/**
 * GA4 Ecommerce event helpers.
 * Uses the standard gtag ecommerce events for conversion funnel tracking.
 * Docs: https://developers.google.com/analytics/devguides/collection/ga4/ecommerce
 */

import { Product, CartItem } from '../types';

const gtag = (...args: any[]) => {
    if (typeof window !== 'undefined' && window.gtag) {
        window.gtag(...args);
    }
};

export function trackViewItem(product: Product) {
    gtag('event', 'view_item', {
        currency: 'MXN',
        value: product.price,
        items: [{
            item_id: String(product.id),
            item_name: product.name,
            item_category: product.category,
            price: product.price,
        }],
    });
}

export function trackAddToCart(item: CartItem) {
    const price = Number(item.selectedPriceInfo.price);
    const quantity = Number(item.selectedPriceInfo.quantity);
    gtag('event', 'add_to_cart', {
        currency: 'MXN',
        value: price,
        items: [{
            item_id: String(item.productId),
            price,
            quantity,
        }],
    });
}

export function trackBeginCheckout(cartItems: CartItem[], cartTotal: number) {
    gtag('event', 'begin_checkout', {
        currency: 'MXN',
        value: cartTotal,
        items: cartItems.map(item => ({
            item_id: String(item.productId),
            item_name: item.selectedOptions['Producto'] || String(item.productId),
            price: Number(item.selectedPriceInfo.price),
            quantity: Number(item.selectedPriceInfo.quantity),
        })),
    });
}

export function trackAddShippingInfo(cartTotal: number, shippingTier?: string) {
    gtag('event', 'add_shipping_info', {
        currency: 'MXN',
        value: cartTotal,
        shipping_tier: shippingTier || 'standard',
    });
}

export function trackAddPaymentInfo(paymentMethod: string, cartTotal: number) {
    gtag('event', 'add_payment_info', {
        currency: 'MXN',
        value: cartTotal,
        payment_type: paymentMethod,
    });
}

export function trackPurchase(orderIds: string[], total: number, shipping: number, tax: number) {
    gtag('event', 'purchase', {
        currency: 'MXN',
        transaction_id: orderIds.join(','),
        value: total,
        shipping,
        tax,
    });
    // Google Ads — Compra conversion
    gtag('event', 'conversion', {
        send_to: 'AW-18004901327/JxjkCO7K54UcEM_7s4lD',
        value: total,
        currency: 'MXN',
        transaction_id: orderIds.join(','),
    });
}

/** Google Ads — Inicio Checkout conversion */
export function trackAdsCheckoutStart(cartTotal: number) {
    gtag('event', 'conversion', {
        send_to: 'AW-18004901327/PfqeCPPA1I8cEM_7s4lD',
        value: cartTotal,
        currency: 'MXN',
    });
}
